const STYLES = [
  { label: "Utility", code: "UT" },
  { label: "Lofted", code: "LB" },
  { label: "Studio", code: "ST" },
] as const;

function styleFromToken(raw: string): string {
  const token = raw.trim().toLowerCase();
  if (!token) return "";
  const byWord = STYLES.find((style) => style.label.toLowerCase() === token);
  if (byWord) return byWord.label;
  const byCode = STYLES.find((style) => style.code.toLowerCase() === token);
  return byCode?.label ?? "";
}

function styleFromCode(code: string): string {
  const last = code.trim().split(/[-_]/).pop() ?? "";
  return styleFromToken(last);
}

function styleFromName(name: string): string {
  const last = name.trim().split(/\s+/).pop() ?? "";
  return styleFromToken(last);
}

function styleFromTags(tags: readonly string[] | undefined): string {
  for (const tag of tags ?? []) {
    const style = styleFromToken(tag);
    if (style) return style;
  }
  return "";
}

/**
 * Models call this Style. ShedCor styles are Utility, Lofted, and Studio.
 * Recipe tags also carry width and material words, so the first tag is not a style.
 */
export function resolvePriceChangeStyle(input: {
  recipeCode?: string;
  recipeName?: string;
  tags?: readonly string[];
  buildRoofStyle?: string | null;
}): string {
  return (
    styleFromCode(input.recipeCode ?? "") ||
    styleFromTags(input.tags) ||
    styleFromName(input.recipeName ?? "") ||
    styleFromToken(input.buildRoofStyle ?? "")
  );
}

export function applyPriceChangeStyles<T extends { code: string; name: string; roof_style: string }>(
  lines: readonly T[],
): T[] {
  return lines.map((line) => {
    const roof_style = resolvePriceChangeStyle({
      recipeCode: line.code,
      recipeName: line.name,
      tags: [line.roof_style],
      buildRoofStyle: line.roof_style,
    });
    return roof_style === line.roof_style ? line : { ...line, roof_style };
  });
}
